/**
 * notificationTypes.js — All notification type constants.
 *
 * Add new types here as features expand. This single file is the
 * source of truth so all parts of the app use consistent strings.
 */

export const NOTIFICATION_TYPES = {
  // ── Call Events ─────────────────────────────────────────────────────────────
  CALL_INBOUND:   'call_inbound',
  CALL_OUTBOUND:  'call_outbound',
  CALL_MISSED:    'call_missed',
  CALL_ENDED:     'call_ended',
  CALL_DECLINED:  'call_declined',

  // ── System ──────────────────────────────────────────────────────────────────
  SYSTEM_ALERT:   'system_alert',
  SYSTEM_INFO:    'system_info',

  // ── Future: Tickets, Chat, Tasks ────────────────────────────────────────────
  TICKET_UPDATE:  'ticket_update',
  CHAT_MESSAGE:   'chat_message',
  TASK_ASSIGNED:  'task_assigned',

  // ── Toast-style (if wiring toasts into bus later) ───────────────────────────
  TOAST_SUCCESS:  'toast_success',
  TOAST_ERROR:    'toast_error',
  TOAST_WARNING:  'toast_warning',
  TOAST_INFO:     'toast_info',
}
